(function () {
    'use strict';

    angular.module("imApp").factory("orderLineCreditCauseService", ['$ihttp', function ($ihttp) {
        let service = {
            getOrderLineCreditCause: function (parms) {
                return $ihttp.post({
                    method: 2761,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 2763,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
